<div class="info-container">
  @if (!loading && vista; as v) {
    <section class="detalle" [class.ajustada]="pantallaAncha()">
      <!-- Resumen: estado y lo más consultado. La identidad del equipo
           (identificación, nombre, tipo, cliente) está en el encabezado de la
           página. -->
      <app-dt-card>
        <app-dt-datos destacado>
          <app-dt-dato etiqueta="Estado" ocultarVacio>
            <app-dt-estado
              [tono]="v.conexion.tono"
              [etiqueta]="v.conexion.etiqueta"
            />
          </app-dt-dato>
          <app-dt-dato
            etiqueta="Último reporte"
            [valor]="v.hace ? 'hace ' + (v.hace | lowercase) : null"
          >
            @if (v.hace) {
              <span class="dt-muted fecha">{{ v.ultimoReporte }}</span>
            }
          </app-dt-dato>
          <app-dt-dato
            etiqueta="Asignado a"
            [valor]="v.asignadoA ?? 'Sin asignar'"
          />
          @if (v.protocolo; as p) {
            <app-dt-dato etiqueta="Protocolo" [valor]="p.detectado">
              @if (p.detectado) {
                <span [class]="'dt-badge ' + p.estado">
                  @switch (p.estado) {
                    @case ('coincide') {
                      <mat-icon>check_circle</mat-icon>
                      Coincide con el modelo
                    }
                    @case ('difiere') {
                      <mat-icon>warning</mat-icon>
                      No coincide
                      <button
                        irxBotonIcono
                        tamano="mini"
                        (click)="avisarProtocolo()"
                        [tooltip]="p.mensaje"
                      >
                        <mat-icon>info</mat-icon>
                      </button>
                    }
                    @default {
                      <mat-icon>help</mat-icon>
                      Modelo sin protocolo
                    }
                  }
                </span>
              }
            </app-dt-dato>
          }
        </app-dt-datos>
      </app-dt-card>

      <div class="grilla">
        <div class="columna">
          <app-dt-card titulo="Equipo" icono="memory">
            <app-dt-datos>
              <app-dt-dato etiqueta="Marca y modelo" [valor]="v.marcaModelo" />
              <app-dt-dato
                etiqueta="ID único"
                [valor]="v.uniqueId"
                mono
                copiable
              />
              <app-dt-dato
                etiqueta="Estado de cuenta"
                [valor]="v.estadoCuenta"
              />
              @if (v.numeroSerie) {
                <app-dt-dato
                  etiqueta="Número de serie"
                  [valor]="v.numeroSerie"
                  mono
                  copiable
                />
              }
              <app-dt-dato
                etiqueta="Número de abonado"
                [valor]="v.numeroAbonado"
                mono
                copiable
              />
              <app-dt-dato etiqueta="Teléfono" [valor]="v.telefono" />
            </app-dt-datos>
          </app-dt-card>

          <!-- Comunicación: el protocolo detectado y el último reporte ya
               están en el resumen -->
          <app-dt-card titulo="Comunicación" icono="cell_tower">
            <app-dt-datos>
              @if (v.protocolo; as p) {
                <app-dt-dato
                  etiqueta="Protocolo del modelo"
                  [valor]="p.declarado ?? 'No declarado'"
                />
              }
              <app-dt-dato
                etiqueta="Frecuencia de reporte"
                [valor]="v.frecuencia"
              />
              @if (v.reenvios; as r) {
                <app-dt-dato
                  etiqueta="Reglas de reenvío"
                  [valor]="
                    r.activas
                      ? r.activas + (r.activas === 1 ? ' activa' : ' activas')
                      : 'No hay activas'
                  "
                >
                  <button
                    irxBotonIcono
                    tamano="mini"
                    [disabled]="!r.total"
                    (click)="verReenvios()"
                    [tooltip]="
                      r.total
                        ? 'Ver reglas de reenvío'
                        : 'Sin reglas de reenvío'
                    "
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                </app-dt-dato>
              }
            </app-dt-datos>
          </app-dt-card>

          <!-- LoRaWAN: solo T1000-B -->
          @if (v.lora; as l) {
            <app-dt-card titulo="LoRaWAN" icono="router">
              <app-dt-datos>
                <app-dt-dato
                  etiqueta="DevEUI"
                  [valor]="l.deveui"
                  mono
                  copiable
                />
                <app-dt-dato
                  etiqueta="JoinEUI"
                  [valor]="l.joineui"
                  mono
                  copiable
                />
                <app-dt-dato etiqueta="Señal" [valor]="l.senal" />
                <app-dt-dato
                  etiqueta="Tasa de entrega"
                  [valor]="l.tasaEntrega"
                />
                <app-dt-dato
                  etiqueta="Última comunicación"
                  [valor]="l.ultimaComunicacion"
                />
                <app-dt-dato
                  etiqueta="Último gateway"
                  [valor]="l.ultimoGateway"
                  mono
                  copiable
                >
                  @if (
                    l.ultimoGateway &&
                    l.snrGateway !== undefined &&
                    l.snrGateway !== null
                  ) {
                    <span class="dt-muted">(SNR {{ l.snrGateway }})</span>
                  }
                </app-dt-dato>
                <app-dt-dato
                  etiqueta="Sin comunicación a las"
                  [valor]="
                    l.limiteComunicacion ? l.limiteComunicacion + ' h' : null
                  "
                />
                <app-dt-dato
                  etiqueta="Network Server"
                  [valor]="l.habilitado ? 'Habilitado' : 'Deshabilitado'"
                >
                  <button
                    irxBotonIcono
                    tamano="mini"
                    (click)="verificarEnChirpstack()"
                    tooltip="Verificar el device en ChirpStack"
                  >
                    <mat-icon>travel_explore</mat-icon>
                  </button>
                </app-dt-dato>
              </app-dt-datos>
            </app-dt-card>
          }

          <app-dt-card titulo="SIMs" icono="sim_card">
            <app-dt-sims [sims]="v.sims" />
          </app-dt-card>
        </div>

        <!-- Mapa: ajustada a la pantalla, toma todo el alto de la columna. -->
        <div class="mapa" #contenedorMapa>
          <app-map-card
            [height]="
              pantallaAncha() && altoMapa() ? altoMapa() + 'px' : '320px'
            "
            [config]="mapCardConfig"
            [loading]="loadingMap()"
          ></app-map-card>
        </div>
      </div>
    </section>
  } @else if (!loading) {
    <!-- Sin tracker (no existe, se borró o no hay acceso): sin esto quedaba
         el spinner para siempre. -->
    <app-empty-state
      icon="gps_off"
      message="No se encontró el tracker"
    ></app-empty-state>
  } @else {
    <!-- Mismo cuerpo que el esqueleto de la página: la carga no salta -->
    <app-detalle-esqueleto soloCuerpo></app-detalle-esqueleto>
  }
</div>
